/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2025-12-05 15:45:47
 * @ Description: Footer of the sign in page
 */

import React, { useState } from 'react'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import TwitterIcon from '@mui/icons-material/Twitter'
import YouTubeIcon from '@mui/icons-material/YouTube'

// Centralized lodash imports - much cleaner!
import { get } from '@/utils/lodash'

import logo from '@/assets/images/NewLogoBlue.png'

import {
  Grid,
  Button,
  List,
  Link,
  Typography,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  Box,
} from '@mui/material'
import useAffiliate from '@/hooks/useAffiliate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ContactDialog from '@/housefolios-components/Dialogs/ContactSupport/'

import {
  colorModeToggleIconWrapSx,
  footerSocialIconSx,
} from '@/layout-blueprints/chromeComponentSx'
import {
  signInFooterBrandStackSx,
  signInFooterColumnSx,
  signInFooterContactBtnSx,
  signInFooterContactWrapSx,
  signInFooterCopyrightCenterSx,
  signInFooterCopyrightRowSx,
  signInFooterCopyrightSx,
  signInFooterDesktopBarSx,
  signInFooterInnerCenterSx,
  signInFooterLinksColumnSx,
  signInFooterLogoSx,
  signInFooterMobileBarSx,
  signInFooterMutedLinkSx,
  signInFooterSectionTitleSx,
  signInFooterSideColumnSx,
  signInFooterTaglineDesktopSx,
  signInFooterTaglineSx,
} from '../authChrome'

export default function SignInFooterComponent(props) {
  const hiddenSmDown = useMediaQuery((theme) =>
    theme.breakpoints.down('sm'),
  )
  const hiddenSmUp = useMediaQuery((theme) =>
    theme.breakpoints.up('sm'),
  )

  const [openContact, setOpenContact] = useState(false)

  function getCookie(cName) {
    const name = cName + '='
    const cDecoded = decodeURIComponent(document.cookie) //to be careful
    const cArr = cDecoded.split('; ')
    let res
    cArr.forEach((val) => {
      if (val.indexOf(name) === 0) res = val.substring(name.length)
    })
    return res
  }

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  let source = urlParams.get('source')
  let sourceCookie = getCookie('SourceSignUp')
  const [{ affiliate, affiliateLoading, urlAffiliate }] =
    useAffiliate({
      memberValue:
        sourceCookie === 'null' ? source : sourceCookie || source,
    })

  return (
    <>
      <Grid sx={{ width: '100%' }}>
        {hiddenSmUp ? null : (
          <Grid
            container

            direction="row"
            sx={[signInFooterMobileBarSx, { width: '100%' }]}
          >
            <Grid sx={signInFooterInnerCenterSx}>
              <Grid
                container
                direction="column"
                spacing={3}
                sx={[signInFooterColumnSx, {
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }]}
              >
                <Grid sx={signInFooterBrandStackSx}>
                  <Box
                    component="img"
                    src={
                      get(
                        affiliate,
                        'sidebar.sidebarMemberFullImage.0.url',
                      ) || logo
                    }
                    alt="Housefolios"
                    sx={signInFooterLogoSx}
                  />
                </Grid>

                {!urlAffiliate && (
                  <Grid>
                    <Typography sx={signInFooterTaglineSx}>
                      Helping real estate investors find, fund, and
                      manage single-family residential portfolios to
                      grow lasting wealth.
                    </Typography>
                  </Grid>
                )}

                {urlAffiliate && (
                  <Grid sx={signInFooterContactWrapSx}>
                    <Button
                      onClick={() => setOpenContact(true)}
                      sx={signInFooterContactBtnSx}
                    >
                      Contact Support
                    </Button>
                  </Grid>
                )}

                <Grid>
                  <Grid container direction="row">
                    {!urlAffiliate && (
                      <Grid size={12}>
                        <Grid
                          container
                          direction="column"
                          sx={{
                            alignItems: 'flex-start',
                          }}
                        >
                          <Grid>
                            <Typography
                              variant="h6"
                              sx={signInFooterSectionTitleSx}
                            >
                              Get Started
                            </Typography>
                          </Grid>
                          <Grid>
                            <Link
                              href="/createAccount"
                              sx={signInFooterMutedLinkSx}
                            >
                              Create account
                            </Link>
                          </Grid>
                          <Grid>
                            <Link
                              href="/signin"
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={signInFooterMutedLinkSx}
                            >
                              Sign in
                            </Link>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    {/* <Grid size={6}>
                    <Grid container direction='column' alignItems='flex-start'>
                      <Grid>
                        <Link variant='h6' style={{ color: '#ffffff' }}>About</Link>
                      </Grid> 
                      <Grid>
                        <Link style={{ color: '#cfcfcf' }}>
                          Our Mission
                        </Link>
                      </Grid>
                      <Grid>
                        <Link style={{ color: '#cfcfcf' }}>
                          Blog
                        </Link>
                      </Grid><Grid>
                        <Link style={{ color: '#cfcfcf' }}>
                          Brand Assets
                        </Link>
                      </Grid>
                      <Grid>
                        <Link style={{ color: '#cfcfcf' }}>
                          Partnerships
                        </Link>
                      </Grid>
                    </Grid>
                  </Grid> */}
                  </Grid>
                </Grid>
                <Grid>
                  <Grid
                    container
                    direction="column"
                    sx={{
                      alignItems: 'flex-start',
                    }}
                  >
                    {/* <Grid>
                <Link variant='h6' style={{ color: '#ffffff' }}>Social Media</Link>
              </Grid> */}
                    {!urlAffiliate && (
                      <Grid>
                        <List
                          component="div"
                          sx={{ justifyContent: 'center', '@media (min-width: 1440px)': { justifyContent: 'flex-start' } }}
                        >
                          <Button
                            target="_blank"
                            href="https://www.linkedin.com/company/housefolios/"
                            onClick={(e) => e.preventDefault()}
                            sx={{ p: 0, mr: '0.5rem' }}
                          >
                            <Box component="span" sx={colorModeToggleIconWrapSx}>
                              <LinkedInIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                            </Box>
                          </Button>
                          <Button
                            target="_blank"
                            href="https://www.facebook.com/Housefolios/"
                            onClick={(e) => e.preventDefault()}
                            sx={{ p: 0, mr: '0.5rem' }}
                          >
                            <Box component="span" sx={colorModeToggleIconWrapSx}>
                              <FacebookIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                            </Box>
                          </Button>
                          <Button
                            target="_blank"
                            href="https://www.instagram.com/housefolios/"
                            onClick={(e) => e.preventDefault()}
                            sx={{ p: 0, mr: '0.5rem' }}
                          >
                            <Box component="span" sx={colorModeToggleIconWrapSx}>
                              <InstagramIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                            </Box>
                          </Button>
                          <Button
                            target="_blank"
                            href="https://www.youtube.com/channel/UCrtQVie1gdD6-8puYRM0Auw"
                            onClick={(e) => e.preventDefault()}
                            sx={{ p: 0, mr: '0.5rem' }}
                          >
                            <Box component="span" sx={colorModeToggleIconWrapSx}>
                              <YouTubeIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                            </Box>
                          </Button>
                          <Button
                            target="_blank"
                            href="https://twitter.com/housefolios"
                            onClick={(e) => e.preventDefault()}
                            sx={{ p: 0, mr: '0.5rem' }}
                          >
                            <Box component="span" sx={colorModeToggleIconWrapSx}>
                              <TwitterIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                            </Box>
                          </Button>
                        </List>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid>
                  <Typography sx={signInFooterCopyrightSx}>
                    Copyright {new Date().getFullYear()} © by
                    {(affiliate?.companyName === 'Deal Sauce (Subto)'
                      ? 'Deal Sauce'
                      : affiliate?.companyName) || 'Housefolios'}{' '}
                    Inc. All rights Reserved.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {hiddenSmDown ? null : (
          <Grid
            container
            direction="row"
            sx={[
              signInFooterDesktopBarSx,
              {
                width: '100%',
                alignItems: 'flex-start',
                justifyContent: 'center',
              },
            ]}
          >
            <Grid sx={signInFooterSideColumnSx}>
              <Grid
                container
                direction="column"
                spacing={1}
                sx={{
                  alignItems: 'flex-start',
                }}
              >
                <Grid sx={signInFooterBrandStackSx}>
                  <Box
                    component="img"
                    src={
                      get(
                        affiliate,
                        'sidebar.sidebarMemberFullImage.0.url',
                      ) || logo
                    }
                    alt="Housefolios"
                    sx={signInFooterLogoSx}
                  />
                  {!urlAffiliate && (
                    <Grid>
                      <Typography sx={signInFooterTaglineDesktopSx}>
                        Helping real estate investors find, fund, and
                        manage single-family residential portfolios to
                        grow lasting wealth.
                      </Typography>
                    </Grid>
                  )}
                  {urlAffiliate && (
                    <Button onClick={() => setOpenContact(true)}>
                      Contact Support
                    </Button>
                  )}{' '}
                </Grid>
              </Grid>
            </Grid>
            {!urlAffiliate && (
              <Grid sx={signInFooterLinksColumnSx}>
                <Grid
                  container
                  direction="column"
                  sx={{
                    alignItems: 'flex-start',
                  }}
                >
                  <Grid>
                    <Typography variant="h6" sx={signInFooterSectionTitleSx}>
                      Get Started
                    </Typography>
                  </Grid>
                  <Grid>
                    <Link
                      href="/createAccount"
                      sx={signInFooterMutedLinkSx}
                    >
                      Create account
                    </Link>
                  </Grid>
                  <Grid>
                    <Link
                      href="/signin"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={signInFooterMutedLinkSx}
                    >
                      Sign in
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {/* <Grid>
            <Grid container direction='column' alignItems='flex-start'>
              <Grid>
                <Link variant='h6' style={{ color: '#ffffff' }}>About</Link>
              </Grid> 
              <Grid>
                <Link style={{ color: '#cfcfcf' }}>
                  Our Mission
                </Link>
              </Grid>
              <Grid>
                <Link style={{ color: '#cfcfcf' }}>
                  Blog
                </Link>
              </Grid><Grid>
                <Link style={{ color: '#cfcfcf' }}>
                  Brand Assets
                </Link>
              </Grid>
              <Grid>
                <Link style={{ color: '#cfcfcf' }}>
                  Partnerships
                </Link>
              </Grid>
            </Grid>
          </Grid> */}
            <Grid>
              <Grid
                container
                direction="column"
                sx={{
                  alignItems: 'flex-start',
                }}
              >
                {/* <Grid>
                <Link variant='h6' style={{ color: '#ffffff' }}>Social Media</Link>
              </Grid> */}
                {!urlAffiliate && (
                  <Grid>
                    <List
                      component="div"
                      sx={{ justifyContent: 'center', '@media (min-width: 1440px)': { justifyContent: 'flex-start' } }}
                    >
                      <Button
                        target="_blank"
                        href="https://www.linkedin.com/company/housefolios/"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(14, 118, 168, 0.35)",
                          color: "#fff",
                          backgroundColor: "#0e76a8",
                          backgroundImage: "none",
                          borderColor: "#0e76a8",
                          "&:not(:disabled):hover": { backgroundColor: "#0e76a8", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0c6590" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(14, 118, 168, 0.4), 0 0.0625rem 0.385rem rgba(14, 118, 168, 0.54)" },
                          "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(14, 118, 168, 0.4), 0 0.0625rem 0.385rem rgba(14, 118, 168, 0.54)" },
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "30px !important",
                          width: "30px !important",
                          lineHeight: "30px !important",
                          p: 0,
                          mr: "0.5rem",
                        }}
                      >
                        <Box component="span" sx={colorModeToggleIconWrapSx}>
                          <LinkedInIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                        </Box>
                      </Button>
                      <Button
                        target="_blank"
                        href="https://www.facebook.com/Housefolios/"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(59, 89, 153, 0.35)",
                          color: "#fff",
                          backgroundColor: "#3b5999",
                          backgroundImage: "none",
                          borderColor: "#3b5999",
                          "&:not(:disabled):hover": { backgroundColor: "#3b5999", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#344e87" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(59, 89, 153, 0.4), 0 0.0625rem 0.385rem rgba(59, 89, 153, 0.54)" },
                          "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(59, 89, 153, 0.4), 0 0.0625rem 0.385rem rgba(59, 89, 153, 0.54)" },
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "30px !important",
                          width: "30px !important",
                          lineHeight: "30px !important",
                          p: 0,
                          mr: "0.5rem",
                        }}
                      >
                        <Box component="span" sx={colorModeToggleIconWrapSx}>
                          <FacebookIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                        </Box>
                      </Button>
                      <Button
                        target="_blank"
                        href="https://www.instagram.com/housefolios/"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(228, 64, 95, 0.35)",
                          color: "#fff",
                          backgroundColor: "#e4405f",
                          backgroundImage: "none",
                          borderColor: "#e4405f",
                          "&:not(:disabled):hover": { backgroundColor: "#e4405f", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#e12a4c" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(228, 64, 95, 0.4), 0 0.0625rem 0.385rem rgba(228, 64, 95, 0.54)" },
                          "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(228, 64, 95, 0.4), 0 0.0625rem 0.385rem rgba(228, 64, 95, 0.54)" },
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "30px !important",
                          width: "30px !important",
                          lineHeight: "30px !important",
                          p: 0,
                          mr: "0.5rem",
                        }}
                      >
                        <Box component="span" sx={colorModeToggleIconWrapSx}>
                          <InstagramIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                        </Box>
                      </Button>
                      <Button
                        target="_blank"
                        href="https://www.youtube.com/channel/UCrtQVie1gdD6-8puYRM0Auw"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(205, 32, 31, 0.35)",
                          color: "#fff",
                          backgroundColor: "#cd201f",
                          backgroundImage: "none",
                          borderColor: "#cd201f",
                          "&:not(:disabled):hover": { backgroundColor: "#cd201f", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#b71d1c" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(205, 32, 31, 0.4), 0 0.0625rem 0.385rem rgba(205, 32, 31, 0.54)" },
                          "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(205, 32, 31, 0.4), 0 0.0625rem 0.385rem rgba(205, 32, 31, 0.54)" },
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "30px !important",
                          width: "30px !important",
                          lineHeight: "30px !important",
                          p: 0,
                          mr: "0.5rem",
                        }}
                      >
                        <Box component="span" sx={colorModeToggleIconWrapSx}>
                          <YouTubeIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                        </Box>
                      </Button>
                      <Button
                        target="_blank"
                        href="https://twitter.com/housefolios"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(29, 161, 242, 0.35)",
                          color: "#fff",
                          backgroundColor: "#1da1f2",
                          backgroundImage: "none",
                          borderColor: "#1da1f2",
                          "&:not(:disabled):hover": { backgroundColor: "#1da1f2", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0d95e8" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(29, 161, 242, 0.4), 0 0.0625rem 0.385rem rgba(29, 161, 242, 0.54)" },
                          "&:not(:disabled):not(.active):active": { boxShadow: "0 0.22rem 0.525rem rgba(29, 161, 242, 0.4), 0 0.0625rem 0.385rem rgba(29, 161, 242, 0.54)" },
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "30px !important",
                          width: "30px !important",
                          lineHeight: "30px !important",
                          p: 0,
                          mr: "0.5rem",
                        }}
                      >
                        <Box component="span" sx={colorModeToggleIconWrapSx}>
                          <TwitterIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
                        </Box>
                      </Button>
                    </List>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid size={12} sx={signInFooterCopyrightRowSx}>
              <Typography sx={signInFooterCopyrightCenterSx}>
                Copyright {new Date().getFullYear()} © by{' '}
                {(affiliate?.companyName === 'Deal Sauce (Subto)'
                  ? 'Deal Sauce'
                  : affiliate?.companyName) || 'Housefolios'}{' '}
                Inc. All rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>

      <ContactDialog
        open={openContact}
        handleClose={() => setOpenContact(false)}
        affiliate={affiliate?.memberValue}
        session={props.session}
      />
    </>
  )
}
